class MotionReveal {
  constructor() {
    this.options = {
      threshold: 0.15,
      // Slightly larger margin so things fade in just as they approach
      rootMargin: "0px 0px -50px 0px"
    };

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), this.options);
    this.init();
  }

  init() {
    // TARGET: Only standard content containers. 
    // Exclude 'shopify-section' generally to avoid jarring layout shifts on load.
    // Focus on the content INSIDE the sections.
    const targets = document.querySelectorAll('.card-wrapper, .rich-text__blocks, .image-with-text__content, .product-media-gallery, .reveal-on-scroll');

    targets.forEach((el, index) => {
      // Don't re-init if already handled.
      if (el.classList.contains('motion-init')) return;

      el.classList.add('motion-init');

      // Gentle stagger for grids (like collections)
      if (el.classList.contains('card-wrapper')) {
        // Minimal delay for subtle flow
        let delay = (index % 4) * 100;
        el.style.setProperty('--motion-delay', `${delay}ms`);
      }

      this.observer.observe(el);
    });
  }

  handleIntersect(entries, observer) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }
}

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
  window.motionSystem = new MotionReveal();
});

// Re-init on Shopify Section load (editor support)
document.addEventListener('shopify:section:load', () => {
  if (window.motionSystem) window.motionSystem.init();
});
